<template>
  <div class="inputMailAddress" :class="{ clearAll: checkAll }">
    <label>メールアドレス</label>
    <input
      class="inputMaillAdressArea"
      v-model="mailaddress"
      placeholder="メールアドレスを入力"
      type="email"
      @focus="onFocus"
      @input="onInput"
    />
    <div v-show="isFocus">
      <p :class="{ clearValidation: checkMailAddress }" class="checkItem">
        メールアドレス形式である
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "input-mailaddress",
  data() {
    return {
      mailaddress: "",
      isFocus: false,
    };
  },
  props: {
    initialValue: {
      type: String,
      required: false,
    },
  },
  computed: {
    checkMailAddress() {
      return !!this.mailaddress.match(
        /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
      );
    },
    checkAll() {
      return this.checkMailAddress;
    },
  },
  methods: {
    onFocus() {
      this.isFocus = true;
    },
    onInput() {
      this.$emit("input", {
        value: this.mailaddress,
        check: this.checkAll,
      });
    },
  },
  mounted() {
    if (this.initialValue) {
      this.mailaddress = this.initialValue;
      this.onInput();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.inputMailAddress {
  margin-bottom: 16px;

  label {
    display: block;
    margin-bottom: 4px;
  }
  input {
    font-size: 1rem;
    line-height: 2;
    width: calc(100% - 8px);
    border: none;
    border-bottom: 1px solid #373737;
  }

  .checkItem {
    color: #c0c0c0;
    font-size: 0.75rem;

    &::before {
      content: "✔︎ ";
    }

    &.clearValidation {
      color: #228b22;
    }
  }
  &.clearAll {
    .inputMaillAdressArea {
      border-color: #228b22;
      background: #98fb98;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputMailAddress.vue